import { TokenDecrypt } from "../Shared/Utils/encryptionDecryption";
import axiosInstance from "../Shared/Utils/axiosInstance";
export const errorShow = "Error occurred while fetching data";
const multiPart = "multipart/form-data";
export async function getIECViewData(selectedLanguageId) {
  try {
    const response = await axiosInstance.get(
      `/api/getIECModule?languageId=${selectedLanguageId}`
    );
    return TokenDecrypt(response.data);
  } catch (error) {
    throw new Error(errorShow);
  }
}

export const addIECModuleAPI = async (formData) => {
  const response = await axiosInstance.post("/api/addIECModule", formData, {
    headers: {
      "Content-Type": multiPart,
    },
  });
  return response.data;
};

export async function deleteIECModule(id) {
  try {
    const response = await axiosInstance.delete("/api/deleteIECModule", {
      data: {
        ids: [id],
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(errorShow);
  }
}

export async function approveIECModule(id, remark) {
  try {
    const response = await axiosInstance.post(`/api/iecapproval/${id}`, {
      approvalStatus: "approve",
      remarks: "",
    });
    return response.data;
  } catch (error) {
    throw new Error(errorShow);
  }
}

export async function rejectIECModule(id, remark) {
  try {
    const response = await axiosInstance.post(`/api/iecapproval/${id}`, {
      approvalStatus: "reject",
      remarks: remark,
    });
    return response.data;
  } catch (error) {
    throw new Error(errorShow);
  }
}

export async function updateIECModuleSuperAdmin(
  updateId,
  type,
  audience,
  title,
  description,
  uploadFile,
  translatedTitle
) {
  const audienceJSON = JSON.stringify(audience);
  const formData = new FormData();
  formData.append("video", uploadFile);
  formData.append("category", type);
  formData.append("audience", audienceJSON);
  formData.append("eng_title", title);
  formData.append("description", description);
  formData.append("mar_title", translatedTitle);

  try {
    const response = await axiosInstance.put(
      `/api/UpdateIECModule/${updateId}`,
      formData,
      {
        headers: {
          "Content-Type": multiPart,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(errorShow);
  }
}

export async function addIECModuleSuperAdmin(
  type,
  audience,
  title,
  description,
  uploadFile,
  translatedTitle
) {
  const audienceJSON = JSON.stringify(audience);
  const formData = new FormData();
  formData.append("video", uploadFile);
  formData.append("category", type);
  formData.append("audience", audienceJSON);
  formData.append("eng_title", title);
  formData.append("description", description);
  formData.append("mar_title", translatedTitle);

  try {
    const response = await axiosInstance.post(`/api/addIECModule`, formData, {
      headers: {
        "Content-Type": multiPart,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(errorShow);
  }
}
